var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{style:({ stroke: '#041B0E', strokeWidth: 5, fill: 'none' }),attrs:{"d":_vm.path,"stroke-linecap":"square"}})}
var staticRenderFns = []

export { render, staticRenderFns }